import type {GlobalState} from 'types/store';

export const isAppFocused = (state: GlobalState) => state.appVisibility.focused;
